import View from './view.js'
import React, { useEffect } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data'

// This is needed to ensure
// that if there are no results
// the city will be set to the values
// of the search_term;

export default function Logic(props) {
  let changeAddressCity = useDataChange({
    context: 'contact_method_association',
    viewPath: props.viewPath,
    path: 'postal_address.city',
  })
  let search_term = useDataValue({
    viewPath: props.viewPath,
    context: 'city_search',
    path: 'term',
  })
  useEffect(() => {
    changeAddressCity(search_term)
  }, [search_term])
  return <View {...props} />
}
